<template>
  <div>
    <div v-if="loading" class="text-center p-5">Loading aktiviti...</div>

    <div v-else>
      <div
        v-if="aktiviti.length === 0"
        class="text-center text-muted p-4 border rounded"
      >
        No aktiviti available.
      </div>

      <!-- ✅ Grid View -->
      <div
        v-else
        class="aktiviti-grid"
      >
        <div
          v-for="(item, index) in aktiviti"
          :key="item.id"
          class="aktiviti-card"
        >
          <div class="image-container">
            <a
              v-if="item.urlImage"
              :href="item.urlImage"
              target="_blank"
              title="View Image"
            >
              <img
                :src="item.urlImage"
                alt="Thumbnail"
                class="aktiviti-image"
              />
            </a>
            <div v-else class="text-muted small">No image</div>
          </div>

          <!-- Action buttons -->
          <div class="action-buttons">
            <img
              src="../../assets/img/edit-btn.png"
              width="28"
              class="cursor-pointer"
              @click="openEditAktiviti(item)"
            />
            <img
              src="../../assets/img/delete-btn.png"
              width="28"
              class="cursor-pointer"
              @click="deleteAktiviti(item.id)"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Aktiviti Popup -->
    <div
      v-if="openAktiviti"
      class="upload-popup-overlay"
      @click.self="closeAktiviti"
    >
      <div class="upload-popup-card">
        <button class="close-btn" @click="closeAktiviti">×</button>
        <h4 class="popup-title text-left">Edit Aktiviti</h4>

        <div
          class="upload-dropzone"
          @click="triggerFileInputAktiviti"
          @dragover.prevent
          @drop.prevent="handleDrop"
        >
          <input
            type="file"
            ref="fileInputAktiviti"
            @change="handleFilesAktiviti"
            accept=".png,.jpg,.jpeg"
            style="display:none"
          />

          <!-- Show preview if image uploaded -->
          <div v-if="previewUrlAktiviti" class="image-preview">
            <img :src="previewUrlAktiviti" alt="Preview" class="preview-img" />
          </div>

          <!-- Otherwise show upload prompt -->
          <div v-else class="upload-content">
            <img
              src="../../assets/img/upload.png"
              alt="Upload Icon"
              class="upload-icon"
            />
            <p class="upload-text">Browse File</p>
            <p class="upload-subtitle">Choose a file or drag & drop it here</p>
            <p class="upload-format-text">
              PNG, JPG, or JPEG formats, up to 10 MB
            </p>
          </div>
        </div>

        <!-- File Preview -->
        <div v-if="uploadedFileAktiviti" class="file-preview">
          <span class="file-name">
            <i class="fa fa-paperclip"></i> {{ uploadedFileAktiviti.name }}
          </span>
          <button class="remove-file" @click="removeFileAktiviti">×</button>
        </div>

        <!-- Submit -->
        <button
          class="upload-submit-btn"
          :disabled="isUploading"
          @click="saveAktiviti"
        >
          {{ isUploading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      aktiviti: [],
      loading: false,
      openAktiviti: false,
      selectedAktivitiId: null,
      uploadedFileAktiviti: null,
      previewUrlAktiviti: null,
      uploadedFileUrl: "",
      uploadedFileId: null,
      isUploading: false,
    };
  },
  async mounted() {
    this.loadAktiviti();
  },
  watch: {
  openAktiviti(val) {
    document.body.style.overflow = val ? 'hidden' : '';
  }
},
  methods: {
    async loadAktiviti() {
      this.loading = true;
      try {
        const res = await this.$API.get(this.$GetListAktiviti);
        if (res.status === 200 && Array.isArray(res.data)) {
          this.aktiviti = res.data.map(item => {
            if (item.urlImage && item.urlImage.startsWith("URL: ")) {
              item.urlImage = item.urlImage.substring(5);
            }
            return item;
          });
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    // Open edit popup
    openEditAktiviti(item) {
      this.selectedAktivitiId = item.id;
      this.uploadedFileUrl = item.urlImage || "";
      this.previewUrlAktiviti = item.urlImage || null;
      this.openAktiviti = true;
      document.body.style.overflow = 'hidden';
    },

    // Close popup
    closeAktiviti() {
      this.openAktiviti = false;
      this.selectedAktivitiId = null;
      this.uploadedFileAktiviti = null;
      this.previewUrlAktiviti = null;
      this.uploadedFileUrl = "";
      document.body.style.overflow = 'hidden';
    },

    // Handle file input
    handleFilesAktiviti(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadedFileAktiviti = file;
        this.previewUrlAktiviti = URL.createObjectURL(file);
      }
    },
    removeFileAktiviti() {
      this.uploadedFileAktiviti = null;
      this.previewUrlAktiviti = null;
      this.uploadedFileUrl = "";
    },

    triggerFileInputAktiviti() {
      this.$refs.fileInputAktiviti.click();
    },

    // Save Aktiviti with FormData
    async saveAktiviti() {
  if (!this.selectedAktivitiId) return alert("No Aktiviti selected");
  this.isUploading = true;

  try {
    let fileUrl = this.uploadedFileUrl;
    let fileId = this.uploadedFileId;

    // ✅ If user selected a new file, upload it first
    if (this.uploadedFileAktiviti) {
      const formData = new FormData();
      formData.append("file", this.uploadedFileAktiviti);

      const uploadRes = await this.$API.post(this.$UploadFileActivity, formData, {
        withCredentials: true,
        timeout: 600000
      });

      const uploaded = Array.isArray(uploadRes.data) ? uploadRes.data[0] : uploadRes.data;

      if (!uploaded.success) throw new Error(uploaded.error || "Upload failed");

      fileUrl = uploaded.fileUrl;
      fileId = uploaded.fileId;
    }

    // Now send JSON to save Aktiviti
    const payload = {
      id: this.selectedAktivitiId,
      urlToImage: fileUrl || "",
      fileAwsId: fileId || null,
      status: true
    };

    const res = await this.$API.post(this.$InsertAktiviti, payload, { withCredentials: true });

    alert("✅ Aktiviti saved successfully! ID: " + res.data);
    this.closeAktiviti();
    this.loadAktiviti();
  } catch (err) {
    console.error(err);
    alert("⚠️ Failed to save Aktiviti. " + err.message);
  } finally {
    this.isUploading = false;
  }
},

    // Delete Aktiviti
    async deleteAktiviti(id) {
      if (!confirm("Are you sure you want to delete this Aktiviti?")) return;
      try {
        const formData = new FormData();
        formData.append("id", id);

        await this.$API.post(this.$DeleteAktiviti, formData, { withCredentials: true });
        alert("✅ Aktiviti deleted successfully!");
        this.loadAktiviti();
      } catch (err) {
        console.error(err);
        alert("⚠️ Failed to delete Aktiviti.");
      }
    },

    // Optional: Toggle status
    async toggleStatus(item) {
      item.isUpdatingStatus = true;
      try {
        const formData = new FormData();
        formData.append("id", item.id);
        formData.append("status", item.Status ? 0 : 1);

        await this.$API.post(this.$ToggleStatusAktiviti, formData, { withCredentials: true });
        item.Status = !item.Status;
      } catch (err) {
        console.error(err);
        alert("⚠️ Failed to update status.");
      } finally {
        item.isUpdatingStatus = false;
      }
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

/* ✅ Grid layout for Aktiviti */
.aktiviti-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 32px;
  padding: 20px;
}

/* ✅ Card style */
.aktiviti-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: all 0.2s ease;
}

.aktiviti-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* ✅ Image styling */
.image-container {
  margin-bottom: 12px;
}

.aktiviti-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 8px;
}

/* ✅ Buttons under image */
.action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

/* Popup styles (unchanged) */
.upload-dropzone {
  border: 1px dashed #ccc;
  padding: 20px;
  text-align: center;
  border-radius: 4px;
  margin-top: 10px;
}
.image-preview img {
  max-width: 100%;
  max-height: 200px;
}
.file-preview {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.file-preview .remove-file {
  margin-left: 10px;
  cursor: pointer;
}
</style>
.cursor-pointer {
  cursor: pointer;
}
.upload-dropzone {
  border: 1px dashed #ccc;
  padding: 20px;
  text-align: center;
  border-radius: 4px;
  margin-top: 10px;
}
.image-preview img {
  max-width: 100%;
  max-height: 200px;
}
.file-preview {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.file-preview .remove-file {
  margin-left: 10px;
  cursor: pointer;
}
</style>